<template>
  <div class="tinymce-editor">
    <editor
      v-model="myValue"
      :init="init"
      :disabled="disabled"
    ></editor>
  </div>
</template>
<script>
import axios from "axios";
import tinymce from "tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import "tinymce/plugins/paste";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/preview";
import 'tinymce/plugins/template';
import 'tinymce/plugins/codesample';

//import "/static/tinymce/plugins/lineheight"
//import "tinymce/plugins/wordcount";

export default {
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default:
        "link lists image code table image media preview paste template codesample"
    },
    toolbar: {
      type: [String, Array],
      default:
        "bold italic underline strikethrough image | media fontsizeselect fontselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink code | removeformat"
    }
  },
  data() {
    return {
      init: {
        media_filter_html: false,
        language_url: "/static/tinymce/tinymce-lang-zh@5.2.2.js", //如果语言包不存在，指定一个语言包路径
        language: "zh_CN", //语言
        skin_url: "/static/tinymce/skins/ui/oxide", //如果主题不存在，指定一个主题路径
        content_css: "/static/tinymce/skins/content/default/content.css",
        height: "700px",
        width: this.calcWidth(),
        plugins: this.plugins, //插件
        fontsize_formats: "10pt 12pt 13pt 14pt 18pt 24pt 36pt",
        external_plugins :{
          'lineheight' : 'https://console.sorenenglish.com/plugin.min.js'
        },
        content_style: `
    *                         { padding:0; margin:0; }
    html, body                { height:100%; }
    img                       { max-width:100%; display:block;height:auto; }
    a                         { text-decoration: soren; }
    iframe                    { width: 100%; }
    p                         { line-height:1.6; margin: 0px; font-size:13pt }
    table                     { word-wrap:break-word; word-break:break-all; max-width:100%; border:none; border-color:#999; }
    .mce-object-iframe        { width:100%; box-sizing:border-box; margin:0; padding:0; }
    ul,ol                     { list-style-position:inside; }
    blockquote                {background: #f9f9f9;border-left: 8px solid #bdc0c3;margin: 0 10px;padding: 0.5em 10px;quotes: "\\201C""\\201D""\\2018""\\2019";}
  `,
        // CONFIG: Paste
        paste_retain_style_properties: 'all',
        paste_word_valid_elements: '*[*]',        // word需要它
        paste_data_images: false,                  // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
        paste_convert_word_fake_lists: false,     // 插入word文档需要该属性
        paste_webkit_styles: 'all',
        paste_merge_formats: true,
        nonbreaking_force_tab: false,
        paste_auto_cleanup_on_paste: true,
        force_br_newlines : true,
        forced_root_block : 'p',   //参见http://tinymce.ax-z.cn/configure/content-filtering.php#forced_root_block
        toolbar: [
          "bold italic underline strikethrough visualaid cut copy paste selectall| fontsizeselect lineheight fontselect",
          "forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | image media template codesample",
          "outdent indent blockquote | undo redo | link unlink code | removeformat | preview"
        ], //工具栏
        templates: [
          {title: 'cdate', description: 'cdate', content: '这是模板内容，<b class="cdate">加粗这里将会显示%m/%d/%Y : %H:%M:%S</b>。'},
          {title: '听力练习', description: '听力练习', content: '<p><strong style="background-color: rgb(58, 144, 127); color: rgb(255, 255, 255);">【听力练习】（有难度，选做）</strong></p><p>1）先盲听一遍，看看能听出多少；</p><p>2）对照文本听音频，看看刚才哪里没听出来；</p><p>3）再听、再对照，直到能完全听懂。</p><p>4）选做：水平较高的同学还可以尝试着复述。</p>'}
        ],
        branding: false, //技术支持(Powered by Tiny || 由Tiny驱动)
        menubar: true, //菜单栏
        theme: "silver", //主题
        zIndex: 9999,
        //images_upload_url : "https://houtai.guanqimiao.cn/api/file/uploadLogo"
        images_upload_handler: function (blobInfo, succFun, failFun) {
          var xhr, formData;
          var file = blobInfo.blob();//转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', 'https://console.sorenenglish.com/api/file/uploadLogo');
          xhr.onload = function() {
            var json;
            if (xhr.status != 200) {
              failFun('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.data != 'string') {
              failFun('Invalid JSON: ' + xhr.responseText);
              return;
            }
            succFun(json.data);
          };
          formData = new FormData();
          formData.append('file', file, file.name );//此处与源文档不一样
          xhr.send(formData);
        },
        paste_preprocess: function(plugin, args) {
          //console.log(args.content)
          let newContent = args.content.replace(/line-height: 100%/g,'line-height: 160%')
          let newContent2 = newContent.replace(/font-size: 11pt/g,'font-size: 13pt')
          let newContent3 = newContent2.replace(/color: #494949;/g,'')
          args.content = newContent3
        },
        /*video_template_callback: function(data) {
          console.log(data)
          return '<video :danmu-list="danmuList" :enable-danmu="true" :danmu-btn="false" width="' + data.width + '" height="' + data.height
            + '"' + (data.poster ? ' poster="' + data.poster + '"' : '')
            + ' controls="controls">\n' + '<source src="' + data.source1 + '"'
            + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n'
            + (data.source2 ? '<source src="' + data.source2 + '"'
              + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '')
            + '</video>';
        }*/
        /*setup : function(ed) {
          ed.on('paste', function(e){
            var tinyMceData = tinyMCE.activeEditor.getContent({ format: 'raw' });
            console.log(tinyMceData)
            if(tinyMceData.indexOf('<p><br data-mce-bogus="1"></p>') >= 0) {
              tinyMceData = tinyMceData.replace(/<p><br data-mce-bogus="1"><\/p>/,'');
              console.log(tinyMceData)
              tinyMCE.activeEditor.setContent(tinyMceData, { format: 'raw' });
            }
            //Here you can validate your other content related validations
          });
        }*/
      },
      myValue: this.value
    };
  },
  mounted() {
    tinymce.init({
    });
  },
  methods: {
    calcWidth() {
      return document.body.clientWidth / 1.8 + "px";
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/tinymce.vue